import { SvrConn } from "../utils/axios/index";

/**
 * Verificar Configuración Puesto Trabajo
 */
const getPuestoTrabajo = async () => {
  let res = {};
  try {
    res = await SvrConn.get("/api/workplace/getPuestoTrabajo");
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 * Actualiza el puesto de trabajo
 */
const updatePuestoTrabajo = async (data) => {
  let res = {};
  try 
  {
     res = await SvrConn.post("/api/workplace/updatepuestotrabajo", data);
  } 
  catch (Error) 
  {
    res = Error;
  }
  return res;
};

export { getPuestoTrabajo, updatePuestoTrabajo };
